export const getPredictedIndustries = industries => {
  const industriesArray = industries || [];
  const predicted = industriesArray.length > 0;
  const industryNames = predicted ? industriesArray.map(industry => industry.name) : [];
  return {
    predicted,
    industryNames
  };
};